<lib-datepicker
  [value]="valorInterno()"
  [required]="required()"
  [minDate]="minDate() ?? undefined"
  [maxDate]="maxDateModel()"
  [disabled]="isDisabled()"
  [placeholder]="placeholder()"
  [errorMsg]="errorMsg()"
  (dateChange)="onDateChange($event)"
/>
